<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter" id="rpt1" title="Part I: Place in Geocritical Theory and Practice">
<p class="pn"><span class="right_1" epub:type="pagebreak" id="page_15" title="15"><a href="#/text/9780253037695_Contents#pt1">P<span class="small">ART</span> I</a></span></p>
<p class="pt"><a href="#/text/9780253037695_Contents#pt1">P<span class="small">LACE IN</span> G<span class="small">EOCRITICAL</span> T<span class="small">HEORY AND</span> P<span class="small">RACTICE</span></a><span class="right_1" epub:type="pagebreak" id="page_16" title="16"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253037695_Part_1.vue?1803d259